<script>
export default {
    name: "LoginOTP",
    props: {
        verificationData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        verificationType: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            intervalInstance: null,
            intervalResendCode: 30,
            otpCode: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
            },
        };
    },
    computed: {
        codeEntered() {
            let isEntered = true;
            for (let i = 1; i <= 6; i++) {
                if (!this.otpCode[i]) {
                    isEntered = false;
                    break;
                }
            }

            return isEntered;
        },
    },
    watch: {
        otpCode: {
            handler: function (val) {
                if (val[6]) {
                    this.$refs.otp6.blur();
                } else if (val[5]) {
                    this.$refs.otp6.focus();
                } else if (val[4]) {
                    this.$refs.otp5.focus();
                } else if (val[3]) {
                    this.$refs.otp4.focus();
                } else if (val[2]) {
                    this.$refs.otp3.focus();
                } else if (val[1]) {
                    this.$refs.otp2.focus();
                }
            },
            deep: true,
        },
    },
    methods: {
        clearCode() {
            this.otpCode = {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
            };
            setTimeout(() => {
                this.$refs.otp1.focus();
            }, 300);
        },
        startResendCodeInterval() {
            clearInterval(this.intervalInstance);
            this.intervalResendCode = 30;
            this.intervalInstance = setInterval(() => {
                if (this.intervalResendCode > 0) {
                    this.intervalResendCode--;
                } else {
                    clearInterval(this.intervalInstance);
                }
            }, 1000);
        },
        resendCode() {
            this.clearCode();
            this.$emit('resendCode')
        },
        performVerificationOtp() {
            const code = [];
            for (let i = 1; i <= 6; i++) {
                code.push(this.otpCode[i]);
            }
            this.$emit('performVerificationOtp', code.join(''))
        },
        handleKeyDown(event, index) {
            if (event.key === 'Backspace') {
              this.otpCode[index] = ''

              if (index > 1) {
                this.$refs[`otp${index-1}`].focus()
              }

              return
            }

            if (!this.otpCode[index])
              return

            if (event.key !== 'Tab'
                && event.key !== 'ArrowRight'
                && event.key !== 'ArrowLeft'
            )
                event.preventDefault()



            if ((/^([0-9])$/).test(event.key)) {
                if (index !== 6)
                    this.$refs[`otp${index+1}`].focus()
            }
        }
    }
}
</script>

<template>
    <form
        class="mb-10"
        @submit.prevent="() => {}"
    >
        <p class="text-secondary text-center font-weight-normal">
            We've emailed a verification code to
        </p>
        <h5 class="text-center">
            {{ verificationType === 'email' ? verificationData.email : verificationData.phone_num }}
        </h5>
        <div class="mt-4">
            <p class="text-center">
                Enter the 6-digit code we've sent you
            </p>
            <div class="d-flex justify-content-center">
                <div class="form-box otp-input-wrap">
                    <input
                        ref="otp1"
                        v-model="otpCode[1]"
                        @keydown="handleKeyDown($event, 1)"
                        type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
                <div class="form-box ml-2 otp-input-wrap">
                    <input
                        ref="otp2"
                        @keydown="handleKeyDown($event, 2)"
                        v-model="otpCode[2]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
                <div class="form-box ml-2 otp-input-wrap">
                    <input
                        ref="otp3"
                        @keydown="handleKeyDown($event, 3)"
                        v-model="otpCode[3]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
                <div class="form-box ml-2 otp-input-wrap">
                    <input
                        ref="otp4"
                        @keydown="handleKeyDown($event, 4)"
                        v-model="otpCode[4]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
                <div class="form-box ml-2 otp-input-wrap">
                    <input
                        ref="otp5"
                        @keydown="handleKeyDown($event, 5)"
                        v-model="otpCode[5]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
                <div class="form-box ml-2 otp-input-wrap">
                    <input
                        ref="otp6"
                        @keydown="handleKeyDown($event, 6)"
                        v-model="otpCode[6]" type="text" maxlength="1" id="otp" placeholder="" class="otp-input" />
                </div>
            </div>
        </div>

        <button
            class="btn-dialog btn-sm ok-btn w-100 mt-5"
            :disabled="!codeEntered"
            @click="performVerificationOtp"
        >
            VERIFY ME
        </button>
        <div class="mt-5 text-center">
            <span v-if="intervalResendCode > 0"> Resend code in {{ intervalResendCode }}s</span>
            <a v-else href="javascript:;" class="text-secondary" @click="resendCode">
                Resend code now
            </a>
        </div>
    </form>
</template>

<style scoped lang="scss">
    .form-box.otp-input-wrap {
      padding-top: 14px;
    }
    .otp-input {
        width: 30px;
        height: 30px;
        border-radius: 5px;
        text-align: center;
        font-size: 25px;
        font-weight: 600;
    }
</style>
